import type {StoreFrontMessage} from '../types/storeFrontMessage';
import {en} from './en';
import {enUs} from './enUs';

export const messages: Record<string, StoreFrontMessage> = {
  en,
  'en-US': enUs,
};
